import { $axios } from '@/util/Axios'
import { ApiAttachments } from '@/api/ApiAttachments.js'
import { ApiAuth } from '@/api/ApiAuth'
import { ApiContacts } from '@/api/ApiContacts.js'
import { ApiBookings } from '@/api/ApiBookings.js'
import { ApiBookingCalculations } from '@/api/ApiBookingCalculations.js'
import { ApiOParams } from '@/api/oParams.js'
import { ApiParams } from '@/api/ApiParams.js'
import { ApiDashboard } from '@/api/ApiDashboard.js'
import { ApiEntities } from '@/api/ApiEntities.js'
import { ApiEntityProperties } from '@/api/ApiEntityProperties.js'
import { ApiEntityRates } from '@/api/ApiEntityRates.js'
import { ApiEntitySeasons } from '@/api/ApiEntitySeasons.js'
import { ApiEntitySurcharges } from '@/api/ApiEntitySurcharges.js'
import { ApiEntityUnitCategories } from '@/api/ApiEntityUnitCategories.js'
import { ApiEntityUnits } from '@/api/ApiEntityUnits.js'
import { ApiEntityKeys } from '@/api/ApiEntityKeys.js'
import { ApiInvoicingDocuments } from '@/api/ApiInvoicingDocuments.js'
import { ApiInquiries } from '@/api/ApiInquiries.js'
import { ApiYellowPages } from '@/api/ApiYellowPages.js'

import { ApiLetterheads } from '@/api/ApiLetterheads.js'
import { ApiLetterheadFonts } from '@/api/ApiLetterheadFonts.js'
import { ApiMedia } from '@/api/ApiMedia.js'
import { ApiSettingsBookingTypes } from '@/api/ApiSettingsBookingTypes.js'

import { ApiSettingsMail } from '@/api/ApiSettingsMail.js'
import { ApiSettingsApiTokens } from '@/api/ApiSettingsApiTokens.js'
import { ApiSettingsWidgets } from '@/api/ApiSettingsWidgets.js'
import { ApiSettingsNumberRanges } from '@/api/ApiSettingsNumberRanges.js'
import { ApiSettingsInvoicingDocuments } from '@/api/ApiSettingsInvoicingDocuments.js'
import { ApiSettingsSeason } from '@/api/ApiSettingsSeason.js'
import { ApiSettingsLegacyTemplates } from '@/api/ApiSettingsLegacyTemplates.js'
import { ApiSettingsSmtp } from '@/api/ApiSettingsSmtp.js'
import { ApiSettingsMailDesign } from '@/api/ApiSettingsMailDesign.js'
import { ApiSettingsCalendar } from '@/api/ApiSettingsCalendar.js'

import { ApiGsi } from '@/api/3rd/ApiGsi.js'
import { ApiGsc } from '@/api/3rd/ApiGsc.js'

import { Env } from '@/util/Env'

export const tnApi = (useAuth = true, baseUrl = Env('OBU_API_URL')) => {
  if (useAuth) {
    const token = sessionStorage.getItem('token')
    if (token) {
      $axios.setToken(token, 'Bearer')
    }
  }

  const {
    attachmentsCreate,
    attachmentsFind,
    attachmentsLoad,
    attachmentsSave
  } = ApiAttachments($axios, baseUrl)

  const {
    bookingTypeFind,
    bookingTypeLoad,
    bookingTypeRemove,
    bookingTypeSave
  } = ApiSettingsBookingTypes($axios, baseUrl)

  const {
    AuthAaul,
    AuthBridge,
    AuthReset,
    AuthSignOut,
    AuthSignIn
  } = ApiAuth($axios, baseUrl)

  const {
    dashboardStats
  } = ApiDashboard($axios, baseUrl)

  const {
    obuBridgeSignIn,
    obuBridgeLegacyRedirect,
    loadNotifications,
    loadParams,
    checkVies,
    updateUserProfile,
    changePassword,
    loadSignature,
    notificationSetRead,
    notificationSetReadAll,
    saveSignature,
    globalSearch
  } = ApiParams($axios, baseUrl)

  const {
    bookingsEntitiesForCalendar,
    bookingsCalculateCart,
    bookingsCancel,
    bookingsCheck,
    bookingsComplete,
    bookingUpdate,
    bookingsConvert,
    bookingsDocumentsCreate,
    bookingsDocuments,
    bookingChangePeriod,
    bookingsFind,
    bookingUpdateOccupation,
    bookingAddResources,
    bookingsIndex,
    bookingsMigrate,
    bookingsObuAction,
    bookingsPdfUrl,
    bookingsRecalculate,
    bookingsRemove,
    bookingsReservation
  } = ApiBookings($axios, baseUrl)

  const {
    bookingCalculationsLoad,
    bookingCalculationsSave
  } = ApiBookingCalculations($axios, baseUrl)

  const {
    contactsFind,
    contactsLoad,
    contactsSave
  } = ApiContacts($axios, baseUrl)

  const {
    yellowPagesAll
  } = ApiYellowPages($axios, baseUrl)

  const {
    entityKeysAll,
    entityKeysRemove,
    entityKeysSave
  } = ApiEntityKeys($axios, baseUrl)

  const {
    entityPropertiesLoad,
    entityPropertiesSave
  } = ApiEntityProperties($axios, baseUrl)

  const {
    entityRatesLoad,
    entityRatesSave
  } = ApiEntityRates($axios, baseUrl)

  const {
    entitySeasonsCheck,
    entitySeasonsLoad,
    entitySeasonsRemove,
    entitySeasonsSave
  } = ApiEntitySeasons($axios, baseUrl)

  const {
    entitySurchargesCheck,
    entitySurchargesLoad,
    entitySurchargesRemove,
    entitySurchargesSave
  } = ApiEntitySurcharges($axios, baseUrl)

  const {
    entityUnitsFind,
    entityUnitsLoad,
    entityUnitsRemove,
    entityUnitsSave
  } = ApiEntityUnits($axios, baseUrl)

  const {
    entityUnitCategoriesFind,
    entityUnitCategoriesLoad,
    entityUnitCategoriesRemove,
    entityUnitCategoriesSave
  } = ApiEntityUnitCategories($axios, baseUrl)

  const {
    oParamsAll,
    oParamsFind,
    oParamsRemove,
    oParamsSave,
    openFeratel
  } = ApiOParams($axios)

  const {
    entitiesAddSites,
    entitiesAll,
    entitiesFind,
    entitiesGetQualifiedSites,
    entitiesGetSiteContent,
    entitiesMigrate,
    entitiesMigrateMedia,
    entitiesSavePayload,
    entitiesRemoveSite,
    entitiesSaveSiteContent,
    entitiesSave,
    entitiesSaveSettings
  } = ApiEntities($axios, baseUrl)

  const {
    inquiriesBatch,
    inquiriesDiscardAnswer,
    inquiriesFind,
    inquiriesLoad,
    inquiriesPoints,
    inquiriesResendAnswer,
    inquiriesSaveAndSendAnswer,
    inquiriesSetStatus
  } = ApiInquiries($axios, baseUrl)

  const {
    invoicingDocumentsDelete,
    invoicingDocumentsDownload,
    invoicingDocumentsFind,
    invoicingDocumentsLoad,
    invoicingDocumentsOpen,
    invoicingDocumentsRecreate,
    invoicingDocumentsSave
  } = ApiInvoicingDocuments($axios, baseUrl)

  const {
    letterheadsCreate,
    letterheadsDelete,
    letterheadsFind,
    letterheadsLoad,
    letterheadsSave
  } = ApiLetterheads($axios, baseUrl)

  const {
    letterheadFontsLoad,
    letterheadFontsSave
  } = ApiLetterheadFonts($axios, baseUrl)

  const {
    mediaFind,
    mediaLoad,
    mediaUpload
  } = ApiMedia($axios, baseUrl)

  const {
    tokensFind,
    tokensLoad,
    tokensSave
  } = ApiSettingsApiTokens($axios, baseUrl)

  const {
    calendarSettingFind,
    calendarSettingRemove,
    calendarSettingLoadRestrictions,
    calendarSettingSaveRestrictions,
    calendarSettingSaveOptions
  } = ApiSettingsCalendar($axios, baseUrl)

  const {
    widgetsFind,
    widgetsLoad,
    widgetsRemove,
    widgetsSave
  } = ApiSettingsWidgets($axios, baseUrl)

  const {
    invoicingDocumentSettingsFind,
    invoicingDocumentSettingsLoad,
    invoicingDocumentSettingsSave
  } = ApiSettingsInvoicingDocuments($axios, baseUrl)

  const {
    mailDesignsFind,
    mailDesignsLoad,
    mailDesignsRemove,
    mailDesignsSave
  } = ApiSettingsMailDesign($axios, baseUrl)

  const {
    mailSettingsFind,
    mailSettingsLoad,
    mailSettingsSave
  } = ApiSettingsMail($axios, baseUrl)

  const {
    smtpLoad,
    smtpSave,
    smtpTest,
    smtpUndo
  } = ApiSettingsSmtp($axios, baseUrl)

  const {
    seasonsFind,
    seasonsLoad,
    seasonsRemove,
    seasonsSave
  } = ApiSettingsSeason($axios, baseUrl)

  const {
    legacyTemplatesFind,
    legacyTemplatesLoad,
    legacyTemplatesRemove,
    legacyTemplatesSave
  } = ApiSettingsLegacyTemplates($axios, baseUrl)

  const {
    numberRangesFind,
    numberRangesLoad,
    numberRangesSave
  } = ApiSettingsNumberRanges($axios, baseUrl)

  const {
    authGsi,
    authGsiAccounts
  } = ApiGsi($axios, baseUrl)

  const {
    gscDomains,
    shelterDomainsAdd,
    shelterDomainsDetails,
    shelterDomainsDetailsBacklinks,
    shelterDomainsLoad,
    shelterGenerateDisavow,
    shelterGsiRevoke,
    shelterSetStatus,
    shelterUpload
  } = ApiGsc($axios, baseUrl)

  return {
    AuthAaul,
    AuthReset,
    AuthSignIn,
    AuthSignOut,
    AuthBridge,

    attachmentsCreate,
    attachmentsFind,
    attachmentsLoad,
    attachmentsSave,

    bookingsCalculateCart,
    bookingsCancel,
    bookingsCheck,
    bookingsComplete,
    bookingsConvert,
    bookingsDocumentsCreate,
    bookingsDocuments,
    bookingsFind,
    bookingUpdateOccupation,
    bookingsIndex,
    bookingsMigrate,
    bookingsObuAction,
    bookingsPdfUrl,
    bookingsRemove,
    bookingChangePeriod,
    bookingsRecalculate,
    bookingAddResources,
    bookingsReservation,
    bookingUpdate,
    bookingsEntitiesForCalendar,

    bookingTypeFind,
    bookingTypeLoad,
    bookingTypeRemove,
    bookingTypeSave,

    bookingCalculationsLoad,
    bookingCalculationsSave,

    contactsFind,
    contactsLoad,
    contactsSave,

    openFeratel,
    dashboardStats,

    entitiesAll,
    entitiesAddSites,
    entitiesFind,
    entitiesGetQualifiedSites,
    entitiesGetSiteContent,
    entitiesMigrate,
    entitiesMigrateMedia,
    entitiesRemoveSite,
    entitiesSaveSiteContent,
    entitiesSave,
    entitiesSavePayload,
    entitiesSaveSettings,

    yellowPagesAll,

    entityPropertiesLoad,
    entityPropertiesSave,

    entityRatesLoad,
    entityRatesSave,

    entityKeysAll,
    entityKeysRemove,
    entityKeysSave,

    entitySeasonsCheck,
    entitySeasonsLoad,
    entitySeasonsRemove,
    entitySeasonsSave,

    entitySurchargesCheck,
    entitySurchargesLoad,
    entitySurchargesRemove,
    entitySurchargesSave,

    entityUnitCategoriesFind,
    entityUnitCategoriesLoad,
    entityUnitCategoriesRemove,
    entityUnitCategoriesSave,

    entityUnitsFind,
    entityUnitsLoad,
    entityUnitsRemove,
    entityUnitsSave,

    inquiriesBatch,
    inquiriesDiscardAnswer,
    inquiriesFind,
    inquiriesLoad,
    inquiriesPoints,
    inquiriesResendAnswer,
    inquiriesSaveAndSendAnswer,
    inquiriesSetStatus,

    invoicingDocumentsDelete,
    invoicingDocumentsDownload,
    invoicingDocumentsFind,
    invoicingDocumentsLoad,
    invoicingDocumentsOpen,
    invoicingDocumentsRecreate,
    invoicingDocumentsSave,

    letterheadsCreate,
    letterheadsDelete,
    letterheadsFind,
    letterheadsLoad,
    letterheadsSave,

    letterheadFontsLoad,
    letterheadFontsSave,

    obuBridgeSignIn,
    obuBridgeLegacyRedirect,
    loadNotifications,
    notificationSetRead,
    notificationSetReadAll,
    loadParams,
    loadSignature,
    updateUserProfile,
    saveSignature,
    changePassword,
    globalSearch,

    oParamsAll,
    oParamsFind,
    oParamsRemove,
    oParamsSave,
    checkVies,

    invoicingDocumentSettingsFind,
    invoicingDocumentSettingsLoad,
    invoicingDocumentSettingsSave,

    mediaFind,
    mediaLoad,
    mediaUpload,

    widgetsFind,
    widgetsLoad,
    widgetsRemove,
    widgetsSave,

    tokensFind,
    tokensLoad,
    tokensSave,

    mailSettingsFind,
    mailSettingsLoad,
    mailSettingsSave,

    mailDesignsFind,
    mailDesignsLoad,
    mailDesignsRemove,
    mailDesignsSave,

    seasonsFind,
    seasonsLoad,
    seasonsRemove,
    seasonsSave,

    smtpLoad,
    smtpSave,
    smtpTest,
    smtpUndo,

    legacyTemplatesFind,
    legacyTemplatesLoad,
    legacyTemplatesRemove,
    legacyTemplatesSave,

    numberRangesFind,
    numberRangesLoad,
    numberRangesSave,

    authGsi,
    authGsiAccounts,

    calendarSettingFind,
    calendarSettingRemove,
    calendarSettingLoadRestrictions,
    calendarSettingSaveRestrictions,
    calendarSettingSaveOptions,

    gscDomains,
    shelterDomainsAdd,
    shelterDomainsDetails,
    shelterDomainsDetailsBacklinks,
    shelterDomainsLoad,
    shelterGenerateDisavow,
    shelterGsiRevoke,
    shelterSetStatus,
    shelterUpload
  }
}
